import { AppHttpClient } from 'common/core/http/app-http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../../common/core/http/app-http-client.service";
var ShareableLinksApiService = /** @class */ (function () {
    function ShareableLinksApiService(http) {
        this.http = http;
    }
    ShareableLinksApiService.prototype.findByEntryId = function (entryId, params) {
        return this.http.get("drive/entries/" + entryId + "/shareable-link", params);
    };
    ShareableLinksApiService.prototype.findByHash = function (hash, params) {
        return this.http.get("drive/shareable-links/" + hash, params);
    };
    ShareableLinksApiService.prototype.create = function (entryId, params) {
        return this.http.post("drive/entries/" + entryId + "/shareable-link", params);
    };
    ShareableLinksApiService.prototype.update = function (id, params) {
        return this.http.put("drive/shareable-links/" + id, params);
    };
    ShareableLinksApiService.prototype.delete = function (id) {
        return this.http.delete("drive/shareable-links/" + id + ")");
    };
    ShareableLinksApiService.prototype.checkPassword = function (linkId, password) {
        return this.http.post("drive/shareable-links/" + linkId + "/check-password", { password: password });
    };
    /**
     * Import shareable link entry into current user's drive.
     */
    ShareableLinksApiService.prototype.importEntry = function (linkId, password) {
        return this.http.post("drive/shareable-links/" + linkId + "/import", { password: password });
    };
    ShareableLinksApiService.ngInjectableDef = i0.defineInjectable({ factory: function ShareableLinksApiService_Factory() { return new ShareableLinksApiService(i0.inject(i1.AppHttpClient)); }, token: ShareableLinksApiService, providedIn: "root" });
    return ShareableLinksApiService;
}());
export { ShareableLinksApiService };
